var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('SideBar'),_c('div',{staticClass:"lay-out-container scroll-bar",class:{ active: _vm.isCollapse }},[_c('div',{staticClass:"fixed-header"},[_c('LayOutHead')],1),_c('LayOutApp')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }